export const Defaults = {
	hp: 0,
	sold: 0,
	contract_id: '828',
	contract_name: 'Default Lead',
	leadinfo: {
		full_name: 'Defaults',
		phone: '2693253095',
		email: 'fakedefault@gmail.com',
	},
	phone_number: '8778683344',
	fields: {
		cta_header: {
			body: `<p>Within the next 24 hours, you will receive an important phone call from one of our attorneys or case agents that will help gather the final, required information to file your claim.</p>
							<p>You may not recognize this phone number, but please pick up the call so we can complete your claim and our attorney can immediately get to work for you.&nbsp;</p>
							<p>Please do not contact another law firm before we talk with you.</p>
							<p>There is <strong><u>NO charge</u></strong> to you for exploring your options with us. You have absolutely no obligations and there is no upfront charge to you at all, your attorney only gets paid if he wins a settlement for your case!</p>`,
			title: `<p>
								<strong style="color: rgb(230, 0, 0);">Thank you!</strong>
								Based on your answers, your claim may be eligible for significant
                <span style="color: rgb(230, 0, 0);">compensation</span>.
							</p>`,
			button_text: '',
		},
	},
	internal: 1,
	type: 'Internal',
};

export const Debugging = {
	sold: 1,
	contract_id: '828',
	contract_name: 'Default Lead',
	leadinfo: {
		full_name: 'Defaults',
		phone: '2693253095',
		email: 'fakedefault@gmail.com',
	},
	phone_number: '8778683344',
	fields: {
		top: {
			body: '<p><br></p>;',
			title: 'Take the next step towards compensation:',
			button_text: '',
		},
		cta_header: {
			body: `<p>Within the next 24 hours, you will receive an important phone call from one of our attorneys or case agents that will help gather the final, required information to file your claim.</p>
							<p>You may not recognize this phone number, but please pick up the call so we can complete your claim and our attorney can immediately get to work for you.&nbsp;</p>
							<p>Please do not contact another law firm before we talk with you.</p>
							<p>There is <strong><u>NO charge</u></strong> to you for exploring your options with us. You have absolutely no obligations and there is no upfront charge to you at all, your attorney only gets paid if he wins a settlement for your case!</p>`,
			title: `<p>
								<strong style="color: rgb(230, 0, 0);">Thank you!</strong>
								Based on your answers, your claim may be eligible for significant
                <span style="color: rgb(230, 0, 0);">compensation</span>.
							</p>`,
			button_text: '',
		},

		call_now: {
			body: '<p><span style="color: rgb(0, 0, 0); "> We have friendly intake advocates available 24 / 7. </span></p >',
			title: 'Call Now',
			button_text: 'Speak to an Intake Advocate',
		},

		sms: {
			body: '<p class="ql-align:center;"> Don\'t like phone calls? Send us a SMS</p>',
			title: 'Text Message(SMS)',
			button_text: 'Send SMS',
		},

		schedule_call: {
			body: '<p class="ql - align - center"> Don\'t like phone calls? Send us a SMS</p>',
			title: 'Text Message(SMS)',
			button_text: 'Send SMS',
		},

		chat: {
			body: '<p class="ql - align - center"> Don\'t like phone calls? Send us a SMS</p>',
			title: 'Text Message(SMS)',
			button_text: 'Send SMS',
		},
	},
	internal: 1,
	type: 'Internal',
};
